import { render, staticRenderFns } from "./CadastroAlergiaTipo.vue?vue&type=template&id=4bc168ac&scoped=true&"
import script from "./CadastroAlergiaTipo.vue?vue&type=script&lang=js&"
export * from "./CadastroAlergiaTipo.vue?vue&type=script&lang=js&"
import style0 from "./CadastroAlergiaTipo.vue?vue&type=style&index=0&id=4bc168ac&scoped=true&lang=css&"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc168ac",
  null
  
)

export default component.exports